import React from "react"

function IconMenu({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="menu"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-menu"
      {...props}
    >
      <path
        d="M21.18 17.168a.899.899 0 0 1 .113 1.79l-.112.007H2.644a.899.899 0 0 1-.113-1.79l.113-.007h18.537zm0-6.021a.899.899 0 0 1 .113 1.79l-.112.007H2.644a.899.899 0 0 1-.113-1.79l.113-.007h18.537zm0-6.02a.899.899 0 0 1 .113 1.79l-.112.007H2.644a.899.899 0 0 1-.113-1.79l.113-.007h18.537z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMenu
